/* ==========================================================================
   Carrinho lateral — Variante V3
   Só cola visual: sincroniza o contador do header, o estado vazio e as setas
   do carrossel "Compre junto". Nenhuma lógica de carrinho é reimplementada.
   ========================================================================== */
(function () {
  'use strict';

  var SIDEBAR_ID = 'halo-cart-sidebar';

  function getSidebar() {
    var el = document.getElementById(SIDEBAR_ID);
    return el && el.classList.contains('cart-sidebar--v3') ? el : null;
  }

  /* ---- header: contador + estado vazio ---------------------------------- */

  function syncHeader(sidebar) {
    var cart = sidebar.querySelector('[data-v3-cart]');
    if (!cart) return;

    var count = parseInt(cart.getAttribute('data-v3-item-count'), 10) || 0;
    sidebar.classList.toggle('is-empty', count === 0);

    var counter = sidebar.querySelector('[data-v3-cart-count]');
    if (counter) {
      counter.innerHTML = cart.getAttribute('data-v3-count-label') || '';
    }
  }

  /* ---- carrossel "Compre junto" ----------------------------------------- */

  function getTrack(button) {
    var block = button.closest('[data-v3-upsell]');
    return block ? block.querySelector('.recommend-slider .swiper-wrapper') : null;
  }

  function refreshArrows(sidebar) {
    sidebar.querySelectorAll('[data-v3-upsell]').forEach(function (block) {
      var track = block.querySelector('.recommend-slider .swiper-wrapper');
      var prev = block.querySelector('[data-v3-upsell-prev]');
      var next = block.querySelector('[data-v3-upsell-next]');

      // o upsell é preenchido por AJAX; sem produtos, o bloco inteiro some
      var hasItems = !!track && track.querySelector('.item-recommend') !== null;
      block.classList.toggle('is-hidden', !hasItems);
      if (!hasItems || !prev || !next) return;

      var scrollable = track.scrollWidth - track.clientWidth > 2;
      prev.disabled = !scrollable || track.scrollLeft <= 2;
      next.disabled = !scrollable || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    });
  }

  function bindOnce() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-v3-upsell-prev], [data-v3-upsell-next]');
      if (!button) return;

      event.preventDefault();
      var track = getTrack(button);
      if (!track) return;

      var step = track.clientWidth || 260;
      var dir = button.hasAttribute('data-v3-upsell-next') ? 1 : -1;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      function (event) {
        var target = event.target;
        if (target && target.classList && target.classList.contains('swiper-wrapper')) {
          var sidebar = getSidebar();
          if (sidebar) refreshArrows(sidebar);
        }
      },
      true
    );
  }

  /* ---- boot ------------------------------------------------------------- */

  var pending = null;

  function refresh() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      var sidebar = getSidebar();
      if (!sidebar) return;
      syncHeader(sidebar);
      refreshArrows(sidebar);
    });
  }

  function init() {
    var sidebar = getSidebar();
    if (!sidebar) return;

    bindOnce();
    refresh();

    // o conteúdo do drawer é trocado por AJAX (halo.updateSidebarCart)
    var wrapper = sidebar.querySelector('.halo-sidebar-wrapper');
    if (wrapper && window.MutationObserver) {
      new MutationObserver(function () {
        refresh();
      }).observe(wrapper, { childList: true, subtree: true });
    }

    document.addEventListener('cart-update', refresh);
    window.addEventListener('resize', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
